import { render, staticRenderFns } from "./FeaturedItemCard.vue?vue&type=template&id=07741b14&scoped=true"
import script from "./FeaturedItemCard.vue?vue&type=script&lang=ts"
export * from "./FeaturedItemCard.vue?vue&type=script&lang=ts"
import style0 from "./FeaturedItemCard.vue?vue&type=style&index=0&id=07741b14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07741b14",
  null
  
)

export default component.exports